import React, { Component } from 'react';
import 'chart.js/auto';
import Select from 'react-select';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { format } from 'date-fns';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// const exportTableToExcel = (tablesGroups, filename = 'fund-data.xlsx') => {
//   const workbook = XLSX.utils.book_new();
  
//   tablesGroups.forEach((tableIds, index) => {
//     const sheetName = `Sheet${index + 1}`;
//     const worksheet = XLSX.utils.aoa_to_sheet([]);

//     tableIds.forEach((tableId) => {
//       const table = document.getElementById(tableId);
//       if (table) {
//         const sheetData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table), { header: 1 });

//         // Adding table data to the worksheet
//         XLSX.utils.sheet_add_aoa(worksheet, sheetData, { origin: -1 });

//         // Copying table styles
//         const tableElement = document.getElementById(tableId);
//         const rows = tableElement.getElementsByTagName('tr');
//         for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
//           const cells = rows[rowIndex].getElementsByTagName('td');
//           for (let cellIndex = 0; cellIndex < cells.length; cellIndex++) {
//             const cellStyle = window.getComputedStyle(cells[cellIndex]);
//             const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: cellIndex });

//             if (!worksheet[cellAddress]) worksheet[cellAddress] = {};

//             worksheet[cellAddress].s = {
//               fill: {
//                 fgColor: { rgb: cellStyle.backgroundColor.replace('#', '') }
//               },
//               font: {
//                 name: cellStyle.fontFamily,
//                 sz: parseInt(cellStyle.fontSize),
//                 color: { rgb: cellStyle.color.replace('#', '') }
//               },
//               alignment: {
//                 horizontal: cellStyle.textAlign,
//                 vertical: cellStyle.verticalAlign
//               },
//               border: {
//                 top: { style: 'thin', color: { rgb: cellStyle.borderTopColor.replace('#', '') } },
//                 bottom: { style: 'thin', color: { rgb: cellStyle.borderBottomColor.replace('#', '') } },
//                 left: { style: 'thin', color: { rgb: cellStyle.borderLeftColor.replace('#', '') } },
//                 right: { style: 'thin', color: { rgb: cellStyle.borderRightColor.replace('#', '') } }
//               }
//             };
//           }
//         }
//       }
//     });

//     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
//   });

//   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
//   saveAs(data, filename);
// };

// const exportTableToExcel1 = (tablesGroups, filename = 'multi-tables.xlsx') => {
//   const workbook = XLSX.utils.book_new();
  
//   console.log("tablesGroups", tablesGroups)
//   tablesGroups.forEach((tableIds, index) => {
//     const sheetName = `Sheet${index + 1}`;
//     const worksheet = XLSX.utils.aoa_to_sheet([]);

//     tableIds.forEach((tableId) => {
//       const table = document.getElementById(tableId);
//       if (table) {
//         const sheetData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table), { header: 1 });
//         XLSX.utils.sheet_add_aoa(worksheet, sheetData, { origin: -1 });
//       }
//     });

//     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
//   });

//   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
//   saveAs(data, filename);
// };

const ExportPDF = ({ targetRef }) => {
  const handleExportPDF = () => {
    const input = targetRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 10, 10);
      pdf.save('download.pdf');
    });
  };

  return (
    <button onClick={handleExportPDF}>Export to PDF</button>
  );
};

class SIPSWPWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCalculationPeriod: true,
      selectedFund: null,
      selectedNature: null,
      selectedSubNature: null,
      selectedGroupSubNature: null,
      selectedScheme: [],
      amount: 10000,
      productOwners: null,
      fundOptions: [],
      natureOptions: [
        { value: 'Equity', label: 'Equity' },
        { value: 'Debt', label: 'Debt' },
        { value: 'Hybrid', label: 'Hybrid' },
      ],
      groupSubNatureOptions: [],
      schemeOptions: [],
      sipSummary: [],
      detailedData: {},
      schemeSelectionMessage: '',
      calculationPeroiodMessage: '',
      startDate: { month: '01', year: '2020' },
      endDate: { month: '01', year: '2024' },
      comparisonSchemes: [],
      fundResults: [],
      fundResultTable: []
    };
  }


  handleSelectedFundChange = (newSelectedFund) => {
    this.setState({
      selectedFund: newSelectedFund,
      selectedGroupSubNature: null,
      selectedScheme: []
    });
    this.fetchProductGroups(newSelectedFund);
  }

  handleSelectedNatureChange = (newSelectedNature) => {
    this.setState({
      selectedNature: newSelectedNature,
      selectedGroupSubNature: null,
      selectedScheme: []
    });
    this.fetchProductList();
  }

  handleSelectedSubNatureChange = (newSelectedSubNature) => {
    this.setState({ selectedSubNature: newSelectedSubNature });
  }

  handleSelectedGroupSubNatureChange = (newSelectedGroupSubNature) => {
    this.setState({
      selectedGroupSubNature: newSelectedGroupSubNature,
      selectedScheme: []
    });
    this.fetchProductList();
  }

  handleSelectedSchemeChange = (newSelectedScheme) => {
    if (newSelectedScheme.length <= 5) {
      this.setState({ selectedScheme: newSelectedScheme });
      this.setState({ schemeSelectionMessage: "" });
      // this.setState({ selectedScheme: [] });      
    } else {
      this.setState({ schemeSelectionMessage: "Max 5 selections are allowed" });
    }
  }

  handleAmountChange = (event) => {
    const newAmount = event.target.value;
    this.setState({ amount: newAmount });
  }

  handleProductOwnersChange = (newProductOwners) => {
    this.setState({ productOwners: newProductOwners });
  }

  handleAddScheme = () => {
    const { selectedScheme, amount, startDate, endDate, comparisonSchemes } = this.state;
    if (!selectedScheme || !selectedScheme.length) {
      this.setState({ schemeSelectionMessage: "Please select filters" });
    } else {
      this.setState({ showCalculationPeriod: true });
    }
  };

  handleCalculations = () => {
    const { selectedScheme, amount, startDate, endDate, comparisonSchemes } = this.state;
    if (!comparisonSchemes.length) {
      this.setState({ calculationPeroiodMessage: "Please select scheme" });
      return;
    }
    this.setState({ calculationPeroiodMessage: ""});
    this.fetchProductSipData();
  }

  handleStartDateChange = (field, value) => {
    this.setState((prevState) => ({
      startDate: {
        ...prevState.startDate,
        [field]: value
      }
    }));
  }

  handleEndDateChange = (field, value) => {
    this.setState((prevState) => ({
      endDate: {
        ...prevState.endDate,
        [field]: value
      }
    }));
  }

  handleComparisonSchemesChange = (schemeId) => {
    this.setState((prevState) => {
      const { comparisonSchemes } = prevState;
      if (comparisonSchemes.includes(schemeId)) {
        return { comparisonSchemes: comparisonSchemes.filter(id => id !== schemeId) };
      } else {
        return { comparisonSchemes: [...comparisonSchemes, schemeId] };
      }
    });
  }

  componentDidMount() {
    this.fetchProductOwners();
  }

  fetchProductOwners = async () => {
    try {
      const { config } = this.props;
      const apiUrl = `${config.PY_API_URL}product/owners`;
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (response.ok) {
        this.setState({
          fundOptions: data.data.product_owners,
        });
      } else {
        console.error('Failed to fetch product_owners data:', data.error);
      }
    } catch (error) {
      console.error('Failed to fetch product_owners data:', error);
    }
  };

  fetchProductGroups = async (newSelectedFund) => {
    try {
      const { config } = this.props;
      const apiUrl = `${config.PY_API_URL}product/groups?product_owner=${newSelectedFund.id}`;
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (response.ok) {
        this.setState({
          groupSubNatureOptions: data.data.fund_groups,
        });
      } else {
        console.error('Failed to fetch product_owners data:', data.error);
      }
    } catch (error) {
      console.error('Failed to fetch product_owners data:', error);
    }
  };

  fetchProductList = async () => {
    try {
      const { config } = this.props;
      const { selectedFund, selectedGroupSubNature } = this.state;
      let apiUrl = `${config.PY_API_URL}product/list?product_owner=${selectedFund.id}`;
      if (selectedGroupSubNature) {
        apiUrl = `${apiUrl}&product_group=${selectedGroupSubNature.product_code}`;
      }
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (response.ok) {
        this.setState({
          schemeOptions: data.data.products,
        });
      } else {
        console.error('Failed to fetch product_owners data:', data.error);
      }
    } catch (error) {
      console.error('Failed to fetch product_owners data:', error);
    }
  };

  fetchProductSipData = async () => {
    try {
      const { config } = this.props;
      const { selectedScheme, amount, startDate, endDate, comparisonSchemes } = this.state;
      const schemeCodes = comparisonSchemes;
      // const schemeCodes = comparisonSchemes.length > 0 ? comparisonSchemes : selectedScheme.map(s => s.scheme_code);
      const apiUrl = `${config.PY_API_URL}/sip/summary?scheme_code=${schemeCodes.join('|')}&start_date=${startDate.year}-${startDate.month}-01&end_date=${endDate.year}-${endDate.month}-28&amount=${amount}`;
      const response = await fetch(apiUrl);
      const data = await response.json();
      if (response.ok) {
        this.processSipSummary(data.data.data);
      } else {
        console.error('Failed to fetch SIP data:', data.error);
      }
    } catch (error) {
      console.error('Failed to fetch SIP data:', error);
    }
  };

  processSipSummary = (funds) => {
    let fundResults = [];
    let fundResultTable = [];
    const { selectedScheme} = this.state;
    for (const [key, data] of Object.entries(funds)) {
      let noOfInstallments = data.summary.length;
      let totalInvestment = data.summary[noOfInstallments - 1]?.totalInvested;
      let currentValue = data.summary[noOfInstallments - 1]?.currentValue;
      let sipStartDate = data.summary[0]?.nav_date;
      let sipEndDate = data.summary[noOfInstallments - 1]?.nav_date;
      let totalProfit = data.summary[noOfInstallments - 1]?.pl;
      let avgHoldingDays = 0;
      avgHoldingDays = Math.floor((new Date(sipEndDate) - new Date(sipStartDate)) / (1000 * 3600 * 24));
      let absolute = ((totalProfit / totalInvestment) * 100).toFixed(2);
      let xirr = data.summary[noOfInstallments - 1]?.xirr;

      const detailedData = {
        ...this.state.detailedData,
        schemeName: data.details?.name,
        schemeCode: data.details?.scheme_code,
        asOnDate: sipEndDate,
        sipAmount: totalInvestment?.toLocaleString(),
        sipStartDate,
        noOfInstallments,
        sipEndDate,
        totalInvestment: totalInvestment?.toLocaleString(),
        absolute,
        currentValue: currentValue?.toLocaleString(),
        xirr,
        totalProfit: totalProfit?.toLocaleString(),
        avgHoldingDays: avgHoldingDays,
        transactions: data.summary
      };
      let res = [
        `summ_${data.details?.scheme_code}`,
        `data_${data.details?.scheme_code}`,
      ];
      fundResultTable.push(res);
      fundResults.push({ sipSummary: data.summary, detailedData })
    }
    this.setState({ fundResults: fundResults });
    this.setState({ fundResultTable: fundResultTable });
  }

  handleReset = () => {
    this.setState({
      selectedFund: null,
      selectedNature: null,
      selectedSubNature:      null,
      selectedGroupSubNature: null,
      selectedScheme: [],
      amount: 10000,
      sipSummary: [],
      schemeSelectionMessage: '',
      startDate: { month: '01', year: '2020' },
      endDate: { month: '01', year: '2024' },
      comparisonSchemes: [],
      fundResults: [],
      showCalculationPeriod: false
    });
  }

  

  render() {
    const {
      fundOptions, selectedFund, natureOptions, selectedNature, selectedSubNature,
      groupSubNatureOptions, selectedGroupSubNature, schemeOptions, selectedScheme,
      amount, schemeSelectionMessage, startDate, endDate, comparisonSchemes,
      fundResults, showCalculationPeriod,
      calculationPeroiodMessage, fundResultTable
    } = this.state;

    const { config } = this.props;

    const monthOptions = this.generateMonthOptions();
    const yearOptions = this.generateYearOptions();

    let containerWidth = ((window.innerWidth - 50) * fundResults.length) + 100;

    const dateFormat = (date) => {
      return <span>{format(date, 'dd MMM yyyy')}</span>;
    };

    const formatNumber = (num) => {
      if (typeof num )
      if (!num || num <= 0) {
        return "-";
      }
      num = parseInt(num);
      let formated = new Intl.NumberFormat('en-IN').format(num);
      if (formated == NaN || formated == "NaN") {
        return '--';
      }
      return formated;
    };

    return (
      <div>
        <div className='row'>
          <div className="tracker-container">
            <h3>SIP-SWP Performance Tracker</h3>
            <div className="tabs">
              <button className="tab-button active">SIP Performance Tracker</button>
              {/* <button className="tab-button">SWP Performance Tracker</button> */}
              {/* <button className="tab-button">SIP Stepup Performance Tracker</button> */}
            </div>
            <div className="filters">
              <h4>Filters</h4>
              <div className="filter-row">
                <div className="filter-column">
                  <label>Fund :</label>
                  <Select 
                    options={fundOptions} 
                    value={selectedFund} 
                    onChange={this.handleSelectedFundChange} 
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    />
                </div>
                {/* <div className="filter-column">
                  <label>Nature :</label>
                  <Select options={natureOptions} value={selectedNature} onChange={this.handleSelectedNatureChange} />
                </div> */}
                <div className="filter-column">
                  <label>Group Sub Nature :</label>
                  <Select 
                    options={groupSubNatureOptions} 
                    value={selectedGroupSubNature} 
                    onChange={this.handleSelectedGroupSubNatureChange} 
                    getOptionLabel={(option) => option.product_common_name}
                    getOptionValue={(option) => option.product_code}
                  />
                </div>
                <div className="filter-column">
                  <label>Schemes :</label>
                  <Select 
                    options={schemeOptions} 
                    value={selectedScheme} 
                    onChange={this.handleSelectedSchemeChange} 
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.scheme_code}
                    isMulti
                  />
                  <span className='error'>{schemeSelectionMessage}</span>
                </div>
              </div>
              <div className="filter-row">
                <div className="filter-column">
                  <label>Amount :</label>
                  <input
                    type="number"
                    value={amount}
                    onChange={this.handleAmountChange}
                  />
                </div>
              </div>
              <div className="buttons">
                <button className="add-button" onClick={this.handleAddScheme}>Add Upto 5 Scheme</button>
                <button className="reset-button" onClick={this.handleReset}>Reset</button>
              </div>
            </div>
          </div>
        </div>


        {showCalculationPeriod && (
          <div className='row'>
            <div className='tracker-container'>
              <div className="calculation-period-container">
                <h3>Calculation Period</h3>
                <div className="calculation-period-form p15">

                  <div className='row w100p'>
                      {selectedScheme.length > 0 && (
                        <div className='scheme-selection-list'>
                          <h4>Selected Schemes</h4>
                          {selectedScheme.map(scheme => (
                            <div className='scheme-selection-list'>
                              <div className='scheme-selection-check'>
                                <input
                                  type="checkbox"
                                  checked={comparisonSchemes.includes(scheme.scheme_code)}
                                  onChange={() => this.handleComparisonSchemesChange(scheme.scheme_code)}
                                />
                              </div>
                              <div className='scheme-selection-name'>
                                {scheme.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}                
                  </div>
                  <div className='row w100p'>
                      <label>From</label>
                      <Select className='date-inp'
                        options={monthOptions}
                        // value={startDate.month}
                        value={monthOptions.find(option => option.value === startDate.month)}
                        onChange={(option) => this.handleStartDateChange('month', option.value)}
                        placeholder="Select Month"
                      />
                      <Select className='date-inp'
                        options={yearOptions}
                        // value={startDate.year}
                        value={yearOptions.find(option => option.value === startDate.year)}
                        onChange={(option) => this.handleStartDateChange('year', option.value)}
                        placeholder="Select Year"
                      />
                      {/* <select defaultValue="January">
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                        ))}
                      </select>
                      <select defaultValue="2020">
                        {Array.from({ length: 10 }, (_, i) => 2020 + i).map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select> */}
                      <label>To</label>
                      <Select className='date-inp'
                        options={monthOptions}
                        // value={endDate.month}
                        value={monthOptions.find(option => option.value === endDate.month)}
                        onChange={(option) => this.handleEndDateChange('month', option.value)}
                        placeholder="Select Month"
                      />
                      <Select className='date-inp'
                        options={yearOptions}
                        // value={endDate.year}
                        value={yearOptions.find(option => option.value === endDate.year)}
                        onChange={(option) => this.handleEndDateChange('year', option.value)}
                        placeholder="Select Year"
                      />
                      {/* <select defaultValue="June">
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                        ))}
                      </select>
                      <select defaultValue="2024">
                        {Array.from({ length: 10 }, (_, i) => 2020 + i).map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select> */}
                  </div>
                  <span className='error'>{calculationPeroiodMessage}</span>
                </div>
                <div className="calculation-period-buttons p15">
                  <button onClick={this.handleCalculations} className="calculate-btn">Calculation</button>
                  <button onClick={this.handleReset}>Reset</button>
                  {/* <button className="export-btn">Export</button> */}
                </div>
              </div>
            </div>
          </div>
        )}

        {(fundResults && fundResults.length > 0) && (
          <div className='row'>
            {/* <button className='export-btn' onClick={() => exportTableToExcel(fundResultTable)}>
              Export as Excel
            </button> */}
            <div className='tracker-container' style={{ overflow: 'scroll' }}>
              <div className="detailed-table-container p15" style={{ width: `${containerWidth}px`}}>
                {/* <ExportPDF targetRef={tableRef} /> */}                
                {fundResults.map((fundData, index) => (
                  <div className='nav-result-container'>
                    <div className='no-data'>
                      {(fundData && !fundData.sipSummary.length) && (
                        <div>
                          <table className="details-table">
                            <tbody>
                              <tr>
                                <td colSpan="9"><p><b>{fundData.detailedData.schemeName}</b></p></td>
                              </tr>
                              <tr>
                                <td colSpan="9"><p><b>Data not found</b></p></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                    <div className='data-exists'>
                      {fundData.sipSummary && fundData.sipSummary.length > 0 && (
                        <div>
                          
                          <table id={`summ_${fundData.detailedData.schemeCode}`} className="details-table">
                            <tbody>
                            <tr>
                              <td colSpan="9"><p><b>{fundData.detailedData.schemeName}</b></p></td>
                            </tr>
                            <tr>
                              <td colSpan="9"><p><b>As on {dateFormat(fundData.detailedData.sipEndDate)}</b></p></td>
                            </tr>
                              <tr>
                                <td colSpan="2">SIP amount:</td>
                                <td colSpan="2"><b>{fundData.detailedData.sipAmount}</b></td>
                                <td>&nbsp;</td>
                                <td colSpan="2">SIP Start Date:</td>
                                <td colSpan="2"><b>{dateFormat(fundData.detailedData.sipStartDate)}</b></td>
                              </tr>
                              <tr>
                                <td colSpan="2">No of installments:</td>
                                <td colSpan="2"><b>{fundData.detailedData.noOfInstallments}</b></td>
                                <td>&nbsp;</td>
                                <td colSpan="2">SIP End Date:</td>
                                <td colSpan="2"><b>{dateFormat(fundData.detailedData.sipEndDate)}</b></td>
                              </tr>
                              <tr>
                                <td colSpan="2">Total Investment Amt (A):</td>
                                <td colSpan="2"><b>{fundData.detailedData.totalInvestment}</b></td>
                                <td>&nbsp;</td>
                                <td colSpan="2">Absolute (%):</td>
                                <td colSpan="2"><b>{fundData.detailedData.absolute}</b></td>
                              </tr>
                              <tr>
                                <td colSpan="2">Current Value (B):</td>
                                <td colSpan="2"><b>{fundData.detailedData.currentValue}</b></td>
                                <td>&nbsp;</td>
                                <td colSpan="2">XIRR (%):</td>
                                <td colSpan="2"><b>{fundData.detailedData.xirr}</b></td>
                              </tr>
                              <tr>
                                <td colSpan="2">Total Profit (B-A):</td>
                                <td colSpan="2"><b>{fundData.detailedData.totalProfit}</b></td>
                                <td>&nbsp;</td>
                                <td colSpan="2">Avg Holding Days:</td>
                                <td colSpan="2"><b>{fundData.detailedData.avgHoldingDays}</b></td>
                              </tr>
                            </tbody>
                          </table>
                          <table id={`data_${fundData.detailedData.schemeCode}`} className="transaction-table">
                            <thead>
                              <tr>
                                <th className='tcenter'>Date</th>
                                <th className='tcenter'>Tran Type</th>
                                <th className='tright'>SIP Amount</th>
                                <th className='tright'>Total Amt</th>
                                <th className='tright'>NAV</th>
                                <th className='tright'>Units</th>
                                <th className='tright'>Total Units</th>
                                <th className='tright'>Current Value</th>
                                <th className='tright'>P/L</th>
                              </tr>
                            </thead>
                            <tbody>
                              {fundData.sipSummary.map((tran, index) => (
                                <tr key={index}>
                                  <td className='tcenter'>{dateFormat(tran.nav_date)}</td>
                                  <td className='tcenter'>{tran.tranType ? tran.tranType: 'SIP'}</td>
                                  <td className='tright'>{tran.invest_amt ? tran.invest_amt.toLocaleString() : "N/A"}</td>
                                  <td className='tright'>{tran.totalInvested ? tran.totalInvested.toLocaleString() : 'N/A'}</td>
                                  <td className='tright'>{tran.nav_val ? tran.nav_val : "N/A"}</td>
                                  <td className='tright'>{tran.n_units ? tran.n_units : "N/A"}</td>
                                  <td className='tright'>{tran.totalUnits ? tran.totalUnits : 'N/A'}</td>
                                  <td className='tright'>{tran.currentValue ? tran.currentValue.toLocaleString() : 'N/A'}</td>
                                  <td className='tright'>{tran.pl ? tran.pl.toLocaleString() : "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                ))}            
              </div>
            </div>
          </div>
        )}
      </div>
    );

  }

  generateMonthOptions() {
    const months = [
      { value: '01', label: 'January' },
      { value: '02', label: 'February' },
      { value: '03', label: 'March' },
      { value: '04', label: 'April' },
      { value: '05', label: 'May' },
      { value: '06', label: 'June' },
      { value: '07', label: 'July' },
      { value: '08', label: 'August' },
      { value: '09', label: 'September' },
      { value: '10', label: 'October' },
      { value: '11', label: 'November' },
      { value: '12', label: 'December' }
    ];
    return months;
  }

  generateYearOptions() {
    const years = [];
    for (let i = 2000; i <= new Date().getFullYear(); i++) {
      years.push({ value: i.toString(), label: i.toString() });
    }
    return years;
  }
}

export default SIPSWPWidget;
